'use strict';
angular.module('edApp').controller('newsController', ['newsResource', newsController]);

function newsController(newsResource) {
    var ctrl = this;
    ctrl.newsItems = [];
    ctrl.years = [];
    ctrl.months = [];
    ctrl.limitOriginal = null;
    ctrl.paramsObj = {};

    ctrl.init = function (nodeId, categoryIds, limit, includeSpotPrice) {
        ctrl.paramsObj = {
            nodeId: nodeId,
            limit: limit,
            categoryIds: categoryIds,
            includeSpotPrice: includeSpotPrice,
            year: null,
            monthId: null
        };
        ctrl.limitOriginal = limit;
        loadNews();
        loadYears(nodeId);
    }

    ctrl.getFromYear = function (year) {
        ctrl.paramsObj.monthId = null;
        ctrl.paramsObj.limit = ctrl.limitOriginal;
        
        if (year == null) {
            ctrl.paramsObj.year = null;
        } else {
            ctrl.paramsObj.year = year;
        }
        loadNews();

        if(ctrl.paramsObj.year != null) {
            loadMonths(ctrl.paramsObj.nodeId, ctrl.paramsObj.year);
        }
    }

    ctrl.getFromMonth = function (month) {
        ctrl.paramsObj.limit = ctrl.limitOriginal;

        if (month == null) {
            ctrl.paramsObj.monthId = null;
        } else {
            ctrl.paramsObj.monthId = month.Id;
        }
        loadNews();
    }

    ctrl.getAll = function () {
        ctrl.paramsObj.limit = null;
        loadNews();
    }

    function loadNews() {
        newsResource.getNewsItems(ctrl.paramsObj).$promise.then(function (response) {
            ctrl.newsItems = response;
        }, function () {
            alert('error');
        });
    }

    function loadYears(nodeId) {
        newsResource.getYears({ id: nodeId }).$promise.then(function (response) {
            ctrl.years = response;
        }, function () {
            alert('error');
        });
    }

    function loadMonths(nodeId, year) {
        newsResource.getMonths({ id: nodeId, year: year }).$promise.then(function (response) {
            ctrl.months = response;
        }, function () {
            alert('error');
        });
    }
}